<template>
  <div>
    <div class="elasticacheResource-title">
      <div>{{ $t("RAM.AWS.ElasticCache.redisTitle") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceRedis:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:elasticache:elastiCacheResourceRedis:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="elasticacheResource-top">
      <elasti-cache-resource-redis-search
        ref="elastiCacheResourceRedisSearchChild"
      ></elasti-cache-resource-redis-search>
    </div>
    <table-elasticache-resource-redis></table-elasticache-resource-redis>
    <export ref="exportChild"></export>
  </div>
</template>

<script>
import ElastiCacheResourceRedisSearch from "./ElastiCacheResourceRedisSearch";
import TableElasticacheResourceRedis from "./TableElastiCacheResourceRedis";
import Export from "../../../aws/Export";

export default {
  name: "ElasticacheResourceRedis",
  components: {
    ElastiCacheResourceRedisSearch,
    TableElasticacheResourceRedis,
    Export
  },
  data() {
    return {
      loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.loading = true;
      this.companyId = this.$refs.elastiCacheResourceRedisSearchChild.companyId;
      this.$api.resourceManagement
        .updateResource({
          companyId: this.companyId,
          resourceManagement: 18
        })
        .then(res => {
          this.loading = false;
          setTimeout(() => {
            this.$Message.success(this.$t('common.updateSuccess'));
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.$refs.exportChild.openExport(5);
    },
    export: function(chooseType) {
      var exportDTO = {
        accountName: this.$refs.elastiCacheResourceRedisSearchChild.accountName,
        companyId: this.$refs.elastiCacheResourceRedisSearchChild.companyId,
        cacheEngine: 1
      };
      // 点击 是
      if (chooseType == true) {
        this.$refs.exportChild.loading = true;
        exportDTO.exportWithTag = true;
      }
      // 点击 否
      else {
        this.$refs.exportChild.modal_loading = true;
        exportDTO.exportWithTag = false;
      }
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.resourceManagement.exportAwsElastiCache(exportDTO).then(res => {
        let fileName = this.$t('RAM.export.elastiCacheRedis');
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        if (chooseType == true) {
          this.$refs.exportChild.loading = false;
        } else {
          this.$refs.exportChild.modal_loading = false;
        }
        // 关闭导出弹出框
        this.$refs.exportChild.exportModal = false;
        this.$Message.destroy();
        this.$Message.success(this.$t('common.exportSuccess'));
      });
    }
  }
};
</script>

<style scoped>
.elasticacheResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.elasticacheResource-title > div:nth-child(1) {
  float: left;
}
.elasticacheResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.elasticacheResource-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticache/redis/ElastiCacheResourceRedis.vue